import React from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowRight, Fish, Anchor, MapPin, BookOpen } from 'lucide-react';

export const WikiHome: React.FC = () => {
  return (
    <div className="min-h-screen pb-24">
      {/* Hero Section */}
      <div className="relative h-[40vh] min-h-[400px] flex flex-col items-center justify-center text-center px-4 overflow-hidden">
        <div className="absolute inset-0 bg-brand-midnight">
            {/* Background Image Placeholder */}
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-40"></div>
            <div className="absolute inset-0 bg-gradient-to-b from-brand-midnight/0 via-brand-midnight/50 to-brand-midnight"></div>
        </div>
        
        <div className="relative z-10 max-w-3xl mx-auto space-y-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-gold/20 border border-brand-gold/30 text-brand-gold backdrop-blur-md">
            <BookOpen size={14} />
            <span className="text-xs font-bold uppercase tracking-widest">Enciclopédia da Pesca</span>
          </div>
          
          <h1 className="text-5xl font-display font-black text-white uppercase tracking-tight drop-shadow-2xl">
            Wikipesca
          </h1>
          
          <p className="text-lg text-white/80 font-medium max-w-2xl mx-auto leading-relaxed">
            Explore o guia definitivo de espécies, técnicas e destinos. O conhecimento compartilhado da nossa comunidade.
          </p>

          <div className="w-full max-w-xl mx-auto relative group">
            <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
                <Search className="text-white/40 group-focus-within:text-brand-gold transition-colors" size={20} />
            </div>
            <input 
                type="text" 
                placeholder="Busque por peixes, técnicas, iscas..." 
                className="w-full pl-12 pr-6 py-4 bg-white/10 border border-white/10 rounded-2xl text-white placeholder-white/40 backdrop-blur-md focus:outline-none focus:bg-white/15 focus:border-brand-gold/50 transition-all font-medium"
            />
          </div>
        </div>
      </div>

      {/* Categories Grid */}
      <div className="max-w-7xl mx-auto px-4 -mt-10 relative z-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Link to="/wikipesca/peixes" className="group">
                <div className="bg-brand-charcoal/50 border border-white/5 p-8 rounded-3xl backdrop-blur-md hover:bg-white/5 hover:border-brand-gold/30 transition-all duration-300 h-full flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-2xl bg-brand-blue-DEFAULT/10 flex items-center justify-center mb-6 text-brand-blue-DEFAULT group-hover:scale-110 transition-transform">
                        <Fish size={32} />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2 font-display uppercase">Espécies</h3>
                    <p className="text-white/40 text-sm mb-6 flex-grow">Guia completo dos peixes esportivos do Brasil e do mundo.</p>
                    <span className="text-brand-gold text-xs font-black uppercase tracking-widest flex items-center gap-2">
                        Explorar <ArrowRight size={14} />
                    </span>
                </div>
            </Link>

            <Link to="/wikipesca/tecnicas" className="group">
                <div className="bg-brand-charcoal/50 border border-white/5 p-8 rounded-3xl backdrop-blur-md hover:bg-white/5 hover:border-brand-gold/30 transition-all duration-300 h-full flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-2xl bg-brand-orange-DEFAULT/10 flex items-center justify-center mb-6 text-brand-orange-DEFAULT group-hover:scale-110 transition-transform">
                        <Anchor size={32} />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2 font-display uppercase">Técnicas</h3>
                    <p className="text-white/40 text-sm mb-6 flex-grow">Aprenda nós, iscas e montagens para cada situação.</p>
                    <span className="text-brand-gold text-xs font-black uppercase tracking-widest flex items-center gap-2">
                        Aprender <ArrowRight size={14} />
                    </span>
                </div>
            </Link>

            <Link to="/wikipesca/destinos" className="group">
                <div className="bg-brand-charcoal/50 border border-white/5 p-8 rounded-3xl backdrop-blur-md hover:bg-white/5 hover:border-brand-gold/30 transition-all duration-300 h-full flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-2xl bg-green-500/10 flex items-center justify-center mb-6 text-green-500 group-hover:scale-110 transition-transform">
                        <MapPin size={32} />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2 font-display uppercase">Destinos</h3>
                    <p className="text-white/40 text-sm mb-6 flex-grow">Os melhores pontos de pesca por bacia e região.</p>
                    <span className="text-brand-gold text-xs font-black uppercase tracking-widest flex items-center gap-2">
                        Viajar <ArrowRight size={14} />
                    </span>
                </div>
            </Link>
             <Link to="/wikipesca/dicas" className="group">
                <div className="bg-brand-charcoal/50 border border-white/5 p-8 rounded-3xl backdrop-blur-md hover:bg-white/5 hover:border-brand-gold/30 transition-all duration-300 h-full flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-2xl bg-purple-500/10 flex items-center justify-center mb-6 text-purple-500 group-hover:scale-110 transition-transform">
                        <BookOpen size={32} />
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2 font-display uppercase">Dicas</h3>
                    <p className="text-white/40 text-sm mb-6 flex-grow">Artigos e dicas rápidas de nossos especialistas.</p>
                    <span className="text-brand-gold text-xs font-black uppercase tracking-widest flex items-center gap-2">
                        Ler <ArrowRight size={14} />
                    </span>
                </div>
            </Link>
        </div>
      </div>
    </div>
  );
};
